import { mdiFileDocumentMultipleOutline } from '@mdi/js'

export default {
  title: 'News',
  to: 'news-admin',
  icon: mdiFileDocumentMultipleOutline,
  action: 'read',
  resource: 'NewsAdmin',
}
